const menu = {
  key: "auditEvents",
  route: "/system/audit-events",
  label: "sidebar.auditEvents",
  permission: "system.audit.read",
  icon: "faHistory",
  group: "system",
  order: 90
};

export default menu;
